import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_54: FaireProductEntity = {
  token: "legacy_prod_abbott-54",
  type: "product",
  name: "Set of 4 Wood Handle Cheese Knives",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/bf40a876dd71773efc9638087907b0185030e52c20b2a9fedeb2f81c9afd0477.jpeg",
  priceDollars: 32,
  subcategory: "Scissors & Tools",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
